module.exports = __webpack_public_path__ + "static/media/Archive.45d70ee9.png";